import { render, staticRenderFns } from "./all-products-in-a-warehouse.vue?vue&type=template&id=00928de6&scoped=true"
import script from "./all-products-in-a-warehouse.vue?vue&type=script&lang=js"
export * from "./all-products-in-a-warehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00928de6",
  null
  
)

export default component.exports